<script>
import { mapGetters } from 'vuex'
import { demo } from '@/mixins/demo'
import IconBase from '@/components/_common/icons/IconBase'
import LoginIcon from '@/components/_common/icons/library/LoginIcon'
import { fetchLibraries } from '@/api/public-api'
export default {
  name: 'TheNav',
  components: {
    IconBase,
    LoginIcon
  },
  mixins: [demo],
  data () {
    return {
      ovbLogo: require('@/assets/img/ovb_logo_text_only.svg'),
      scrollPosition: 0,
    }
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'brochure/libraryInfo',
      workingLibrary: 'ovb/workingLibrary',
      // guestUserInfo: 'brochure/guestUserInfo',
      licensePlans: 'brochure/licensePlans',
      pricingTag: 'brochure/pricingTag',
      isHomeProgram: 'brochure/isHomeProgram',
      isBrainRehab: 'brochure/isBrainRehab'
    }),
    libraryOptions () {
      return this.libraryInfo.map(o => {
        return {
          ...o,
          value: o.id,
          selected: (o.id === this.workingLibrary.id),
          label: o.id === 'vision' ? 'Vision Therapy' : `${o.name} Therapy`
        }
      })
    },
    showBernellNav () {
      const partnerCode = (typeof this.pricingTag === 'string') ? this.pricingTag.toLowerCase() : null
      return (partnerCode === 'bernell')
    },
    hideTopNav () {
      return (this.$route.path === '/brain-rehab-home')
    },
    isMobile () {
      return this.$mq === 'mobile'
    }
  },
  methods: {
    setDropdownStatus (e) {
      console.log('dropdown', e)
    },
    loginWithRedirect () {
      window.location.href = process.env.VUE_APP_LOGIN_URL || 'https://play.ourvisualbrain.com/login'
    },
    async loadBrochureData () {
      try {
        const data = await fetchLibraries()
        const licensePlans = {
          vision: data.vision,
          occupational: data.occupational
        }
        this.$store.dispatch('brochure/setLicensePlans', licensePlans)
        this.$store.dispatch('brochure/setLibraryInfo', data.libraryInfo.libraries)
        if (!this.workingLibrary) {
          const defaultLib = data.libraryInfo.libraries.find(o => o.id === 'vision')
          this.$store.dispatch('SET_WORKING_LIBRARY', defaultLib)
        }
      } catch (err) {
        console.error('Failed to load brochure data:', err)
      }
    }
  },
  created () {
    this.$eventHub.$on('SHOW_FREE_TRIAL', this.onShowFreeTrial)
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.top.scrollY
    })
    this.loadBrochureData()
  },
  destroyed () {
    window.removeEventListener('scroll', () => {
      this.scrollPosition = window.top.scrollY
    })
  }
}
</script>

<template>
  <b-navbar
      :class="{ 'is-scrolled': scrollPosition > 0, 'is-mobile': isMobile }"
      class="the-nav"
      :shadow="false"
      :spaced="false"
      :fixed-top="true"
      :centered="true"
      :transparent="true"
      v-if="!hideTopNav"
  >
    <template #brand>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            tag="router-link"
            :to="{ path: '/' }"
            class="ovb-logo-nav"
        >
          <img
              class="ovb-text-logo"
              alt="Our Visual Brain"
              :src="ovbLogo"
          />
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item
            tag="router-link"
            :to="{ path: '/brain-rehab' }"
            class="ovb-logo-container"
        >
          <img
              class="ovb-logo"
              :src="require('@/assets/promo/img/OVB_logo_gray.svg')"
              alt="Our Visual Brain: Brain Rehab home"
          >
        </b-navbar-item>
      </template>
    </template>
    <template #start>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            exact-path
            v-if="!isBrainRehab"
            tag="router-link"
            :to="{ name: 'HomeView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Home</div>
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item
            v-if="!isBrainRehab"
            tag="router-link"
            exact-path
            :to="{ name: 'BrainRehab', params: {stickyNav: true}}"
        >
          <div class="nav-text">Home</div>
        </b-navbar-item>
      </template>
      <template v-if="!isHomeProgram && !isBrainRehab">
        <b-navbar-item
            tag="router-link"
            exact
            :to="{ name: 'FeaturesView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Features</div>
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            tag="router-link"
            :to="{ name: 'ActivitiesView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Activities</div>
        </b-navbar-item>
      </template>
      <template v-if="showBernellNav">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ path: '/partners/bernell', params: {stickyNav: true}}"
        >
          <div class="nav-text">Bernell Plans</div>
        </b-navbar-item>
      </template>
      <template v-if="!showBernellNav && !isHomeProgram && !isBrainRehab">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ name: 'PlansView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Plans</div>
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ name: 'AboutView', params: {stickyNav: true}}"
        >
          <div class="nav-text">About</div>
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
<!--        <b-navbar-dropdown-->
<!--            hoverable-->
<!--            @active-change="setDropdownStatus"-->
<!--            label="Info"-->
<!--        >-->
<!--          <b-navbar-item-->
<!--              class="nav-text"-->
<!--              tag="router-link"-->
<!--              :to="{ name: 'AboutView', params: {stickyNav: true}}"> About </b-navbar-item>-->
<!--          <b-navbar-item-->
<!--              class="nav-text"-->
<!--              tag="router-link"-->
<!--              :to="{ name: 'ContactView', params: {stickyNav: true}}"-->
<!--          > Contact </b-navbar-item>-->
<!--        </b-navbar-dropdown>-->
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ name: 'WhatsNewView', params: {stickyNav: true}}"
        >
          <div class="nav-text">What's New</div>
        </b-navbar-item>
      </template>
      <b-navbar-item
          tag="router-link"
          :to="{ name: 'ContactView', params: {stickyNav: true}}"
      >
        <div class="nav-text">Contact</div>
      </b-navbar-item>
    </template>

    <template #end>
      <b-navbar-item
          tag="a"
          tabindex="0"
          class="button-reset"
          href="https://play.ourvisualbrain.com/login"
      >
        <div class="nav-text">Reset</div>
      </b-navbar-item>
      <b-navbar-item
          tag="a"
          tabindex="0"
          class="button-login"
          @click="loginWithRedirect"
      >
        <icon-base :width="18" :height="18" aria-hidden="true">
          <login-icon />
        </icon-base>
        <div class="nav-text login-text">Login</div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<style lang="scss" scoped>
.ovb-text-logo {
  display: block;
  min-width: 13rem;
  padding-top: 4px;
  @include tablet {
    min-width: 13rem;
  }
  @include desktop {
    min-width: 13rem;
  }
}
.button-login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  color: $white;
}
</style>
<style lang="scss">
$transition-time: 1s;
$nav-bottom-border-width: 2px;
.navbar.the-nav {
  background-color: transparent;
  transition: background-color $transition-time ease;
  &:hover {
    background-color: $jet;
  }
  &.is-mobile {
    background-color: $jet;
  }
  &.is-scrolled {
    background-color: $jet;
    //box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
  &:not(.is-promo-home) {
    background-color: $jet;
  }
  .navbar-brand .navbar-item {
    padding-left: 1rem;
  }
  .navbar-item.router-link-active {
    background-color: transparent;
  }
  @media screen and (max-width: 1023px) {
    // this is the mobile nav
    .navbar-menu {
      background-color: $jet;
      .navbar-item.router-link-active {
        color: $white;
        font-weight: 504;
        border-bottom: none;
        &:hover {
          filter: saturate(3);
          border-bottom: none;
        }
        & .nav-text {
          background-color: transparent;
          border-bottom: 2px solid transparent;
          transition: border-color 600ms ease;
          &:hover {
            filter: saturate(3);
            border-bottom: 2px solid $white;
          }
        }
        &.router-link-active .nav-text {
          border-bottom: 2px solid transparent;
          color: $watermelon;
        }
      }
      .navbar-item.has-dropdown {
        .navbar-dropdown {
          border-top: none;
        }
        a.navbar-link {
          color: $white;
          &:not(.is-arrowless)::after {
            border-color: $white;
          }
          &:focus {
            background-color: transparent;
            border-bottom: 1px solid $white;
          }
          &:focus-within {
            background-color: transparent;
          }
          &:hover {
            background-color: transparent;
          }
        }
        &.is-active {
          & a.navbar-link {
            color: $white;
          }
        }
        .navbar-item.nav-text {
          color: $white;
        }
      }
    }
  }
  .navbar-item.has-dropdown {
    & a.navbar-link {
      color: $white;
      &:not(.is-arrowless)::after {
        border-color: $white;
      }
    }
    &.is-active {
      & a.navbar-link {
        color: $white;
      }
    }
    .navbar-item.nav-text {
      color: $white;
    }
  }
  .navbar-item {
    color: $white;
    font-weight: 504;
    border-bottom: none;
    &:hover {
      filter: saturate(3);
      border-bottom: none;
    }
    & .nav-text {
      background-color: transparent;
      border-bottom: 2px solid transparent;
      transition: border-color 600ms ease;
      &:hover {
        filter: saturate(3);
        border-bottom: 2px solid $white;
      }
    }
    &.router-link-active .nav-text{
      border-bottom: 2px solid $watermelon;
      color: $watermelon;
    }
    .navbar-dropdown {
      color: $white;
      background-color: $jet;
      border-top: 2px solid $watermelon;
      .navbar-item {
        color: $white;
        font-weight: 504;
      }
    }
  }
  .navbar-brand .navbar-item.ovb-logo-nav {
    border-bottom: none;
    &:hover {
      border-bottom: none;
    }
  }
  .text-outline {
    filter: url('#outline');
  }
  .navbar-burger {
    width: 4rem;
    height: 4rem;
  }
  .navbar-brand, .navbar-tabs {
    min-height: auto;
  }
  .navbar-item img {
    max-height: none;
  }
}
</style>

